import { PaginationData } from './JobsList.utils';

export const DEFAULT_PAGINATION_DATA: Required<PaginationData> = {
  currentPage: 1,
  itemsPerPage: 10,
  count: 10,
  lastPage: 0,
};

export const sortByGroupOptions = [
  'partner',
  'title',
  'whenToStart',
  'createdAt',
  'status',
  'numberOfDevs',
  'developerType',
  'salaryRange',
];

export const fieldsAndFriendlyLabels = {
  partner: 'Partner',
  title: 'Title',
  whenToStart: 'When To Start',
  createdAt: 'Time Open',
  status: 'Status',
  numberOfDevs: '# Of Talents',
  developerType: 'Developer Type',
  salaryRange: 'Salary Range',
};

export const fieldsAndFriendlyLabelsList = Object.entries(fieldsAndFriendlyLabels);

export const DEFAULT_SORT_BY = {
  order: 'ASC',
  column: 'partner',
};
